import DOMPurify from "dompurify";

const IFRAME_SANDBOX =
  "allow-scripts allow-same-origin allow-popups allow-presentation";

// Authored HTML documents may legitimately embed video via <iframe> (RTE's
// "insertvideo" toolbar button); force a sandbox so an embedded page can't
// break out of its frame even though its src is otherwise unrestricted.
DOMPurify.addHook("uponSanitizeElement", (node, data) => {
  if (data.tagName === "iframe") {
    (node as Element).setAttribute("sandbox", IFRAME_SANDBOX);
    (node as Element).setAttribute("referrerpolicy", "no-referrer");
  }
});

export const sanitizeHtml = (html: string | null | undefined): string => {
  return html ? DOMPurify.sanitize(html) : "";
};

export const sanitizeHtmlDocument = (
  html: string | null | undefined
): string => {
  return html
    ? DOMPurify.sanitize(html, {
        ADD_TAGS: ["iframe"],
        ADD_ATTR: [
          "allow",
          "allowfullscreen",
          "frameborder",
          "scrolling",
          "sandbox",
          "referrerpolicy"
        ]
      })
    : "";
};
